export const isLayersTenant = () => {
  return window.location.hostname.includes('layers');
};
